export default __webpack_public_path__ + "static/media/nets-icon.9af8f531.jpeg";